import { observer } from 'mobx-react';
import { GroupResource } from '../../../../GroupsStore/Types';
import MulticheckActions from '../../../../Multicheck/MulticheckActions';
import { MulticheckStore } from '../../../../Multicheck/Store';
import { Link } from '../../../../Resource/Types';
import AddLicenseToGroups from './AddLicenseToGroups';

interface Props {
  multicheckStore: MulticheckStore<GroupResource>;
  links: ReadonlyArray<Link>;
}

function BulkActions({ multicheckStore, links }: Props) {
  return (
    <MulticheckActions store={multicheckStore}>
      <AddLicenseToGroups links={links} multicheckStore={multicheckStore} />
    </MulticheckActions>
  );
}

export default observer(BulkActions);
